import { CONTACT } from "@/data/site";

export const telHref = `tel:${CONTACT.phoneRaw}`;
export const smsHref = `sms:${CONTACT.phoneRaw}?&body=${encodeURIComponent(CONTACT.smsBody)}`;
export const mailHref = `mailto:${CONTACT.email}`;

export const scrollTo = (hash) => {
  const el = document.querySelector(hash);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};
